var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addForm,
            rules: _vm.rules,
            "label-width": "210px",
          },
        },
        [
          _c("el-row", { staticClass: "formTitle" }, [_vm._v("专家分配")]),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "分配专家最大个数：", prop: "maxExpertNum" },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "3", "show-word-limit": "" },
                    model: {
                      value: _vm.addForm.maxExpertNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "maxExpertNum", $$v)
                      },
                      expression: "addForm.maxExpertNum",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否规避本校专家：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.isBelongSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "isBelongSchool", $$v)
                        },
                        expression: "addForm.isBelongSchool",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row", { staticClass: "formTitle" }, [_vm._v("评分规则")]),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "评分规则：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.scoreRules,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "scoreRules", $$v)
                        },
                        expression: "addForm.scoreRules",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("平均分"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("去最大最小值取平均分"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "专家最少浏览时间（分钟）：",
                    prop: "minViewTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "3", "show-word-limit": "" },
                    model: {
                      value: _vm.addForm.minViewTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "minViewTime", $$v)
                      },
                      expression: "addForm.minViewTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("addForm")
                    },
                  },
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.isBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }